"use strict";

exports.__esModule = true;
var styles = {
  root: {
    flexGrow: 1
  },
  select: {
    width: '100%',
    margin: '8px 8px 8px 0px'
  },
  selectUbicacion: {
    margin: '24px 8px 8px 8px'
  }
};
exports["default"] = styles;